import { UserWithCompany } from "@/utils/types";
import { CompanyType } from "prisma/cm/client";

export enum EcsUserType {
  VC = "vc", // vcs
  NON_CM_ECS_PARTICIPANT = "non_cm_ecs_participant", // non-cm, ecs
  CM_ECS_PARTICIPANT = "cm_ecs_participant", // cm, not ecs
  SHARE_LINK_RECIPIENT = "share_link_recipient", // recipient of a share link
  UNKNOWN = "unknown",

  /**
   * vcs
   * non-cm with published survey results
   * cm participants (normal cm users with published survey results)
   * recipients (shared via links - future feature)
   */
}

export function getEcsUserType(user: UserWithCompany) {
  let ecsUserType: EcsUserType = EcsUserType.UNKNOWN;

  if (!user.company) return ecsUserType;

  const companyType = user.company.companyType;

  switch (companyType) {
    case CompanyType.VC:
      ecsUserType = EcsUserType.VC;
      break;
    case CompanyType.ECS:
      ecsUserType = EcsUserType.NON_CM_ECS_PARTICIPANT;
      break;
    case CompanyType.STANDARD:
      ecsUserType = EcsUserType.CM_ECS_PARTICIPANT;
      break;
  }

  return ecsUserType;
}
